<template>
  <v-chip :class="classModifier">{{ status }}</v-chip>
</template>

<script>
export default {
  props: ['status'],
  data() {
    return {
      colorMap: {
        Processing: 'blue',
        Finished: 'green',
        Archived: 'gray',
        Cancelled: 'orange'
      },
    };
  },
  computed: {
    classModifier() {
      return `hvh-chip hvh-chip--${this.colorMap[this.status] || 'default'}`;
    },
  },
};
</script>
